// Placeholder for a live number in the prerendered HTML. Roughly as wide as "61,613"
// so the swap to the real number after React mounts barely moves the layout.
export const CountSkeleton = () => (
  <span
    aria-hidden
    data-prerender-skeleton
    className="inline-block w-[3.2em] h-[0.8em] rounded-[4px] bg-current opacity-20 align-middle"
  />
);
